module.exports = __webpack_public_path__ + "static/img/pc-02.38d4489.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/w11/pc-02.jpg
// module id = twQt
// module chunks = 1